import { render, staticRenderFns } from "./CoursewareShelfDialogAddChooser.vue?vue&type=template&id=53192c4a&scoped=true&"
import script from "./CoursewareShelfDialogAddChooser.vue?vue&type=script&lang=js&"
export * from "./CoursewareShelfDialogAddChooser.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareShelfDialogAddChooser.vue?vue&type=style&index=0&id=53192c4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53192c4a",
  null
  
)

export default component.exports